import { render, staticRenderFns } from "./serPackage.vue?vue&type=template&id=6b4a84ef&scoped=true"
import script from "./serPackage.vue?vue&type=script&lang=js"
export * from "./serPackage.vue?vue&type=script&lang=js"
import style0 from "./serPackage.vue?vue&type=style&index=0&id=6b4a84ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a84ef",
  null
  
)

export default component.exports